var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamePlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_gameplanicon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M385.72,774.52c7.47,9.06,18.48,14.26,30.21,14.26c0.69,0,1.39-0.02,2.03-0.06c12.34-0.65,23.78-7.17,30.6-17.46 l326.02-491.57c11.93-17.99,7-42.33-11-54.27c-6.44-4.27-13.91-6.52-21.6-6.52c-13.16,0-25.37,6.54-32.66,17.51l-296.78,447.5 L280.59,523.73c-7.46-9.06-18.49-14.26-30.24-14.26c-9.04,0-17.88,3.17-24.87,8.93c-8.07,6.65-13.07,16.04-14.08,26.45 c-1.01,10.41,2.1,20.59,8.75,28.66L385.72,774.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.44,0H125.56C56.33,0,0,56.33,0,125.56v748.88C0,943.67,56.33,1000,125.56,1000h748.88 c69.23,0,125.56-56.33,125.56-125.56V125.56C1000,56.33,943.67,0,874.44,0z M78.3,125.56c0-26.06,21.2-47.26,47.26-47.26h748.88 c26.06,0,47.26,21.2,47.26,47.26v748.88c0,26.06-21.2,47.26-47.26,47.26H125.56c-26.06,0-47.26-21.2-47.26-47.26V125.56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamePlanIcon);
export default __webpack_public_path__ + "static/media/gamePlanIcon.3c52c17416738ff3a15b5b36a63b6143.svg";
export { ForwardRef as ReactComponent };